// extracted by mini-css-extract-plugin
module.exports = {"loginWrapper":"SSO_loginWrapper__kv01S"};